import { Component, OnInit, ViewChild } from "@angular/core";
import { MatSnackBar, MatSnackBarConfig } from "@angular/material/snack-bar";
import { DataSharingService } from "src/app/AuthGuard/DataSharingService";
import { ReportsService } from "../services/reports.service";
import { MatTableDataSource } from "@angular/material/table";
import { MatPaginator } from "@angular/material/paginator";
import { SnackbarComponent } from "src/app/snackbar/snackbar.component";
import { DialogService } from "src/app/Shared/dialog.service";
@Component({
  selector: "app-report-monthly-dpd",
  templateUrl: "./report-monthly-dpd.component.html",
  styleUrls: ["./report-monthly-dpd.component.scss"],
})
export class ReportMonthlyDpdComponent implements OnInit {
  showSpinner: boolean = false;
  monthlyType: any = "dpd";
  ToDate: Date = new Date();

  selectedId: any;
  dataSource: any;
  data = [];

  displayedColumns: string[] = [];

  dynamicColumns: string[] = [];
  fixedColumns: any;
  processColumns: any;
  JsonData: any;
  @ViewChild(MatPaginator) paginator: MatPaginator;
  pageTitle: any = "REPORTS";

  configSuccess: MatSnackBarConfig = {
    panelClass: "style-success",
    duration: 5000,
    horizontalPosition: "right",
    verticalPosition: "top",
  };

  constructor(
    private dataSharingService: DataSharingService,
    private reportsService: ReportsService,
    public snackBar: MatSnackBar,
    private dialog: DialogService
  ) {}

  ngOnInit(): void {
    this.dataSharingService.HeaderTitle.next("Monthly OD/DPD Analysis");
  }

  // function to show the last date only in date picker
  onlyAllowLastDate = (d: Date | null): boolean => {
    if (!(d instanceof Date) || isNaN(d.getTime())) {
      return false; // Ensure d is a valid Date object
    }

    const year = d.getFullYear();
    const month = d.getMonth();

    // Get the last date of the given month
    const lastDayOfMonth = new Date(year, month + 1, 0).getDate();

    // Enable only if the date is the last day of the month
    return d.getDate() === lastDayOfMonth;
  };

  onOpenCalendar(container) {
    container.monthSelectHandler = (event: any): void => {
      container._store.dispatch(container._actions.select(event.date));
    };
    container.setViewMode("month");
  }

  search() {
    this.dialog
      .openConfirmDialog(
        `This report can take time to generate due to complex calculations. Please have patience!`
      )
      .afterClosed()
      .subscribe((dialogResult) => {
        if (dialogResult == false) {
          return;
        } else {
          this.showSpinner = true;
          if (this.monthlyType == "dpd") {
            console.log("inside dpd condition");
            this.reportsService
              .Report_MothlyDPD({
                ToDate: new Date(
                  this.ToDate.getFullYear(),
                  this.ToDate.getMonth() + 1,
                  0
                ),
              })
              .subscribe((response: any) => {
                if (response.length > 0) {
                  console.log("Report :", response);
                  this.dataSource = new MatTableDataSource(
                    JSON.parse(JSON.stringify(response))
                  );
                  this.dataSource.paginator = this.paginator;

                  this.fixedColumns = [
                    "Loan_Id",
                    "Application_No",
                    "LoanCreatedOn",
                    "LoanAcNo",
                    "Loan_Date",
                    "Branch_Name",
                    "Product_Name",
                  ];

                  this.dynamicColumns = Object.keys(response[0]).filter(
                    (key) =>
                      !this.fixedColumns.includes(key) &&
                      !key.toLowerCase().includes("id")
                  );

                  this.displayedColumns = [
                    ...this.fixedColumns,
                    ...this.dynamicColumns,
                  ];

                  this.JsonData = response;

                  this.showSpinner = false;
                  console.log(
                    "Spinner value after API call:",
                    this.showSpinner
                  );
                } else {
                  this.snackBar.openFromComponent(SnackbarComponent, {
                    data: "No data found",
                    ...this.configSuccess,
                  });
                  this.dataSource = null;
                  this.showSpinner = false;
                }
              });
          } else {
            this.reportsService
              .Report_MothlyOverdue({
                ToDate: new Date(
                  this.ToDate.getFullYear(),
                  this.ToDate.getMonth() + 1,
                  0
                ),
              })
              .subscribe((response: any) => {
                if (response.length > 0) {
                  console.log("Report :", response);
                  this.dataSource = new MatTableDataSource(
                    JSON.parse(JSON.stringify(response))
                  );
                  this.dataSource.paginator = this.paginator;

                  this.fixedColumns = [
                    "Loan_Id",
                    "Application_No",
                    "LoanCreatedOn",
                    "LoanAcNo",
                    "Loan_Date",
                    "Branch_Name",
                    "Product_Name",
                  ];

                  this.dynamicColumns = Object.keys(response[0]).filter(
                    (key) =>
                      !this.fixedColumns.includes(key) &&
                      !key.toLowerCase().includes("id")
                  );

                  this.displayedColumns = [
                    ...this.fixedColumns,
                    ...this.dynamicColumns,
                  ];

                  this.JsonData = response;

                  this.showSpinner = false;
                  console.log(
                    "Spinner value after API call:",
                    this.showSpinner
                  );
                } else {
                  this.snackBar.openFromComponent(SnackbarComponent, {
                    data: "No data found",
                    ...this.configSuccess,
                  });
                  this.dataSource = null;
                  this.showSpinner = false;
                }
              });
          }
        }
      });
  }

  applyFilter(filterValue: string) {
    this.dataSource.filter = filterValue.trim().toLowerCase();
  }

  public highlightRow(row) {
    this.selectedId = row.Loan_Id;
  }
  exportTable(exporter: any) {
    exporter.exportTable("xls", {
      fileName: "MONTHLY OD/DPD ANALYSIS",
      sheet: "pageTitle",
    });
  }
}
